import type { ReactElement, ReactNode } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { IconBack, IconHome, IconUser, IconUsers } from "./Icons";

/** Barra fixa do topo. Cada tela monta a sua, com titulo e acoes proprias. */
export function PageHeader({
  title,
  back,
  actions,
}: {
  title: string;
  /** true volta uma pagina no historico; string navega para a rota informada. */
  back?: boolean | string;
  actions?: ReactNode;
}): ReactElement {
  const navigate = useNavigate();

  return (
    <header className="app-bar">
      <div className="app-bar-inner">
        {back ? (
          <button
            type="button"
            className="btn-icon"
            aria-label="Voltar"
            onClick={() => (typeof back === "string" ? navigate(back) : navigate(-1))}
          >
            <IconBack />
          </button>
        ) : (
          <span style={{ width: 8 }} />
        )}
        <h1 className="app-bar-title">{title}</h1>
        {actions}
      </div>
    </header>
  );
}

const NAV_ITEMS = [
  { to: "/app", label: "Início", Icon: IconHome, end: true },
  { to: "/app/pessoas", label: "Pessoas", Icon: IconUsers, end: false },
  { to: "/app/perfil", label: "Perfil", Icon: IconUser, end: false },
];

/** Casca de todas as telas logadas: conteudo + barra de navegacao de baixo. */
export function AppShell(): ReactElement {
  return (
    <div className="app-shell">
      <Outlet />
      <nav className="bottom-nav" aria-label="Navegação principal">
        <div className="bottom-nav-inner">
          {NAV_ITEMS.map(({ to, label, Icon, end }) => (
            <NavLink key={to} to={to} end={end}>
              {({ isActive }) => (
                <>
                  <Icon aria-hidden="true" />
                  <span>{label}</span>
                  {isActive ? <span className="sr-only">(atual)</span> : null}
                </>
              )}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
